import React, { useState } from "react";
import { Link, NavLink } from 'react-router-dom';
import './Header.css';
import {
  Stack,
  Toolbar,
  Typography,
  Container,
  AppBar,
  Button,
  Drawer,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
const pages = [
  { name: "Home", id: "/" },
  { name: "About Us", id: "/about" },
  { name: "Products & Services", id: "/services" },
  { name: "Contact Us", id: "/contact" },
];
const Nav = () => {
  const [open, setOpen] = useState(false);
  const toggleDrawer = newOpen => () => {
    setOpen(newOpen);
  };
  return (
    <>
      <Button
        variant="text"
        onClick={toggleDrawer(true)}
        sx={{ color: "black", display: { xs: "flex", sm: "none" } }}
      >
        <MenuIcon />
      </Button>
      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
        anchor="right"
        sx={{
          display: { xs: "inherit", sm: "none" },
          "& .MuiDrawer-paper": {
            height: "100%",
            width: "100%",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
          }}
        >
          <Button onClick={toggleDrawer(false)}>
            <CloseIcon />
          </Button>
        </Box>
        <NavList onClick={toggleDrawer(false)} />
      </Drawer>
      <NavList 
        sx={{
          display: { xs: "none", sm: "inherit" },
        }}
      />
    </>
  );
};
const NavList = ({ ...props }) => {
  return (
    <Stack
      overflow="auto"
      direction={{ xs: "column", sm: "row" }}
      gap={3}
      width={{ xs: "100%", sm: "initial" }}
      textAlign={{ xs: "center", sm: "initial" }}
      fontSize={{ xs: "22px", sm: "initial" }}
      {...props}
    >
      {pages.map(page => (
        <NavLink        
          to={page.id} 
          activeClassName="active-link"
          key={page.id}
        >
          <Button color="inherit" 
           sx={{
            color: { xs: "primary", sm: "black" },
            textDecoration: "bold",
          }}  
          >
            {page.name}
            </Button>
        </NavLink>
      ))}
    </Stack>
  );
};
const Header = () => {
  return (
    <AppBar class = "header">
      <Container>
        <Toolbar>
          <Stack 
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            height= "5rem"
          >
            <Typography variant="h6">
              <div className="logo-section">
                <Link to="/" className="logo-link">
                  <img src="/logo.png" alt="Zenith World Wide Company" className="logo" />
                </Link>
              </div>
            </Typography>
            <Nav />
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Header;